"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithCSSTransition = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var WithCSSTransition = function (props) {
    var visible = props.in, _a = props.dimension, dimension = _a === void 0 ? 'height' : _a, children = props.children, rest = __rest(props, ["in", "dimension", "children"]);
    var expandedSize = react_1.default.useRef(0);
    var dimensionCamelCase = dimension === 'height' ? 'Height' : 'Width';
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, __assign({ in: visible, timeout: 200, unmountOnExit: true, onEnter: function (node) {
            node.style["min".concat(dimensionCamelCase)] = 'initial';
            node.style[dimension] = '0px';
        }, onEntering: function (node) {
            node.style[dimension] = "".concat(expandedSize.current, "px");
        }, onEntered: function (node) {
            node.style["min".concat(dimensionCamelCase)] = '';
            node.style[dimension] = '';
        }, onExit: function (node) {
            node.style[dimension] = "".concat(expandedSize.current, "px");
        }, onExiting: function (node) {
            node.style["min".concat(dimensionCamelCase)] = 'initial';
            node.style[dimension] = '0px';
        }, classNames: 'iui' }, rest), react_1.default.cloneElement(children, {
        ref: function (el) {
            if (el) {
                expandedSize.current = el.getBoundingClientRect()[dimension];
            }
        },
    })));
};
exports.WithCSSTransition = WithCSSTransition;
exports.default = exports.WithCSSTransition;
